import React from 'react';
import logo from './medstarLogo.png';

export default function Logo({ siteTitle = 'medstarhealth' }) {
   return <img src={logo} alt={siteTitle} title={siteTitle} />;
}
